/* ====================================================================
   AKIBA — theme.js
   Comportements communs : menu tiroir + animations au scroll.
   (Le JS spécifique à chaque page est dans sa section.)
==================================================================== */
(function () {
  'use strict';

  /* ---- Menu tiroir ---- */
  function initDrawer() {
    var drawer = document.querySelector('.menu-drawer');
    var overlay = document.querySelector('.menu-overlay');
    if (!drawer || !overlay) return;

    function open() { drawer.classList.add('is-open'); overlay.classList.add('is-open'); }
    function close() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); }

    document.querySelectorAll('.js-menu-open').forEach(function (b) { b.addEventListener('click', open); });
    document.querySelectorAll('.js-menu-close').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Animations au scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { initDrawer(); initReveal(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
